import { DirectiveOptions } from 'vue';
import { debounce } from 'lodash';

function adjustColumnWidth(table) {
  const colgroup = table.querySelector("colgroup");
  const colDefs = colgroup.querySelectorAll("col");
  colDefs.forEach(col => {
    const clsName = col.getAttribute("name");
    const cells = [
      ...table.querySelectorAll(`td.${clsName}`),
      ...table.querySelectorAll(`th.${clsName}`),
    ];
    //Ignoring columns with class' leave alone '
    if (cells[0]?.classList?.contains?.("leave-alone")) {
      return;
    }
    const widthList = cells.map((el) => {
      const textContent = el.querySelector('.cell')?.textContent?.trim();
      const rullerCanvas = document.createElement('canvas');
      const context = rullerCanvas.getContext("2d");
      context.font = "14px OpenSans";
      return Math.ceil(context.measureText(textContent).width);
    });
    const max = Math.max(...widthList);
    console.log('adjustColumnWidth %s width: %d', clsName, max);
    const padding = 32;
    table.querySelectorAll(`col[name=${clsName}]`).forEach(el => {
      el.setAttribute("width", max + padding);
    });
  });
}

const updateColumnsWidth = debounce(el => adjustColumnWidth(el), 5000);

export const fitColumns: DirectiveOptions = {
  inserted(el) {
    updateColumnsWidth(el);
  },
  componentUpdated(el) {
    el.classList.add("r-table");
    updateColumnsWidth(el);
  }
};